// Fix-by windows (guide 13.4). A failed item's fix-by window sets the default due date
// of its action item; the due date itself is what drives overdue flags in V2.
export const FIX_BY_WINDOWS = ['24hrs', '1week', '2weeks', 'before_next_blueprint'] as const;
export type FixByWindow = (typeof FIX_BY_WINDOWS)[number];

export const FIX_BY_LABELS: Record<FixByWindow, string> = {
  '24hrs': '24 hours',
  '1week': '1 week',
  '2weeks': '2 weeks',
  before_next_blueprint: 'Before next blueprint',
};

const DAYS: Record<Exclude<FixByWindow, 'before_next_blueprint'>, number> = {
  '24hrs': 1,
  '1week': 7,
  '2weeks': 14,
};

// Dates are plain YYYY-MM-DD strings in the app's time zone.
export function addDays(date: string, days: number): string {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);
}

// Due date for a fix-by window, or null for "before next blueprint" (no calendar date).
export function dueDateFor(window: FixByWindow, auditDate: string): string | null {
  if (window === 'before_next_blueprint') return null;
  return addDays(auditDate, DAYS[window]);
}

// Days past due (0 when not overdue or no due date).
export function overdueDays(dueDate: string | null, today: string): number {
  if (!dueDate) return 0;
  const d = daysBetween(dueDate, today);
  return d > 0 ? d : 0;
}

// Today's date (YYYY-MM-DD) in a given IANA time zone.
export function todayIn(timeZone: string, now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
